<template>
  <Lock :size="size" :color="color" :stroke-width="strokewidth" :stroke-linecap="strokeLinecap" />
</template>

<script setup>
// src/components/icons/LockIcon.vue

import { Lock } from 'lucide-vue-next'

const props = defineProps({
  size: {
    type: [Number, String],
    default: 20,
  },
  color: {
    type: String,
    default: 'currentColor',
  },
  strokewidth: {
    type: [Number, String],
    default: 1,
  },
  strokeLinecap: {
    type: String,
    default: 'none',
  },
})
</script>
